IndicesRevisionGenerationValidator.$inject = ['validator'];

export default function IndicesRevisionGenerationValidator(validator) {
    const instance = new validator();
    return instance;
}
